import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next'; // Pretpostavljam da koristiš i18n
import { Link } from 'react-router-dom';

const Unsubscribe = () => {
    const { t } = useTranslation();
    const [status, setStatus] = useState("loading"); // "loading", "success", "error"

    const axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_API_URL
    })

    useEffect(() => {
        const unsubscribeProcess = async () => {
            // Čitamo ID iz URL-a (npr. ?id=123444)
            const searchParams = new URLSearchParams(window.location.search);
            const urlId = searchParams.get("id");

            if (!urlId) {
                setStatus("error");
                return;
            }

            try {
                // Pozivamo naš novi endpoint
                const response = await axiosInstance.post("api/unsubscribe", {
                    id: urlId
                });

                if (response.data.success) {
                    setStatus("success");
                } else {
                    setStatus("error");
                }
            } catch (error) {
                console.error("Error unsubscribing", error);
                setStatus("error");
            }
        };

        unsubscribeProcess();
    }, []);

    return (
        <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: "#F5F8FA", padding: "20px" }}>
            <div style={{ backgroundColor: "#fff", padding: "40px", borderRadius: "10px", boxShadow: "0 4px 15px rgba(0,0,0,0.05)", textAlign: "center", maxWidth: "500px" }}>
                
                {status === "loading" && (
                    <>
                        <h2 style={{ color: "#030E4F" }}>{t("Processing your request...")}</h2>
                        <p style={{ color: "#666" }}>{t("Please wait a moment.")}</p>
                    </>
                )}

                {status === "success" && (
                    <>
                        <div style={{ fontSize: "50px", marginBottom: "10px" }}>✅</div>
                        <h2 style={{ color: "#030E4F" }}>{t("Successfully Unsubscribed")}</h2>
                        <p style={{ color: "#666", lineHeight: "1.6" }}>
                            {t("You have been removed from our mailing list. You will not receive any further automated emails from us.")}
                        </p>
                        <Link to="/" style={{ display: "inline-block", marginTop: "20px", color: "#F49F1C", fontWeight: "bold", textDecoration: "none" }}>
                            &larr; {t("Return to Homepage")}
                        </Link>
                    </>
                )}

                {status === "error" && (
                    <>
                        <div style={{ fontSize: "50px", marginBottom: "10px" }}>⚠️</div>
                        <h2 style={{ color: "#d32f2f" }}>{t("Something went wrong")}</h2>
                        <p style={{ color: "#666" }}>
                            {t("We couldn't process your request. The link might be invalid or you are already unsubscribed.")}
                        </p>
                        <Link to="/" style={{ display: "inline-block", marginTop: "20px", color: "#030E4F", fontWeight: "bold", textDecoration: "none" }}>
                            &larr; {t("Return to Homepage")}
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default Unsubscribe;